import { Box } from "@mui/material"
import Helpers from "../../helpers/helpers";
import CustomSelect from "../Form/CustomSelect";
import CustomTextField from "../Form/CustomTextField";
import CustomAutocomplete from "../Form/CustomAutocomplete";
import React, { useEffect } from "react";

const TableStyle2 = ({ header, tableData, inputListing, inputArr, setInput, error, width, customResponsiveTable }) => {
    const [formValue, setFormValue] = React.useState([]);

    useEffect(() => {
        if (inputArr || inputArr?.length === 0) {
            setFormValue(inputArr);
        }
    }, [inputArr])

    const handleChangeInputVal = (field, val, index, num, isArray = false) => {
        let tempFormValue = [...formValue];
        if (isArray) {
            tempFormValue[index][field][num] = val;
        } else {
            tempFormValue[index][field] = val;
        }
        setFormValue(tempFormValue);
        setInput && setInput(tempFormValue);
    }

    const handleRemoveRow = (index) => {
        const updatedFormValue = formValue.filter((_, idx) => idx !== index);
        setFormValue(updatedFormValue);
        setInput && setInput(updatedFormValue);
    }

    const renderInputField = (value, index) => {
        return (
            <tr key={'input-field-' + index}>
                {inputListing?.map((input, idx) => {
                    return (
                        <td key={'input-' + idx} className="py-2 pb-3">
                            {
                                input?.inputType === 'textField' ?
                                    <CustomTextField
                                        values={value?.[input?.name]}
                                        onChange={(e) => handleChangeInputVal(input?.name, e, index)}
                                        placeholder={input?.placeholder}
                                        disabled={input?.disabled || false}
                                        type={input?.type || 'text'}
                                        padding={0.2}
                                        fontSize={14}
                                        paddingBlock={"0px"}
                                        paddingInline={1}
                                        multiline={input?.multiline || false}
                                        rows={input?.rows || 1}
                                        error={error?.[input?.name || input?.error_name] || false}
                                    />
                                    : input?.inputType === 'select' ?
                                        <CustomSelect
                                            icon={false}
                                            values={value?.[input?.name] || '-1'}
                                            onChange={(e) => {
                                                handleChangeInputVal(input?.name, e, index)
                                                if (input?.name === 'salesman_id') {
                                                    const selectedOption = input?.data.find((item) => (item.id || item.value) === e);
                                                    handleChangeInputVal('contact', selectedOption?.phone || '', index);
                                                    handleChangeInputVal('location_id', selectedOption?.branch_id || '', index);
                                                    handleChangeInputVal('location_name', selectedOption?.branch_name || '', index);
                                                }
                                                if (input?.name === "location_id") {
                                                    const selectedOption = input?.data.find((item) => (item.id || item.value) === e);
                                                    handleChangeInputVal('location_name', selectedOption?.branch_name || '', index);
                                                }
                                            }}
                                            placeholder={input?.placeholder}
                                            data={input?.data || []}
                                            labelName={input?.labelName || 'name'}
                                            valueName={input?.valueName || 'id'}
                                            height={30}
                                            marginTop="5px"
                                            padding={"5px"}
                                            error={error?.[input?.name || input?.error_name] || false}
                                        />
                                        : input?.inputType === 'autocomplete' ?
                                            <div className="mt-2">
                                                <CustomAutocomplete
                                                    values={value?.[input?.name] || "-1"}
                                                    placeholder={input?.placeholder}
                                                    data={input?.data || []}
                                                    onChange={(e, value) => handleChangeInputVal(input?.name, value?.[input?.valueName || 'id'] || value, index)}
                                                    padding={'1px'}
                                                    labelName={input?.labelName || 'label'}
                                                    valueName={input?.valueName || 'value'}
                                                    freeSolo={input?.freeSolo || false}
                                                    error={error?.[input?.name || input?.error_name] || false}
                                                />
                                            </div>
                                            : input?.actionName ?
                                                <div className="d-flex justify-content-row">
                                                    <div
                                                        style={{ color: '#B48A3C', cursor: 'pointer', textDecoration: 'underline' }}
                                                        onClick={() => { input?.actionOnClick(value) }}
                                                    >
                                                        {input?.actionName}
                                                    </div>

                                                    {input?.removeAction && (
                                                        <div className="mx-3 clickable" onClick={() => handleRemoveRow(index)} style={{ color: '#D13536' }}>
                                                            Remove
                                                        </div>
                                                    )}

                                                </div>

                                                : input?.view ?
                                                    value?.[input?.name] || '-'
                                                    : <></>
                            }
                        </td>
                    );
                })}
            </tr>
        )
    }
    return (
        <Box sx={{ overflow: 'auto' }}>
            {
                width && width <= 768 ?
                    customResponsiveTable
                    :
                    <table id="details-table" style={{ width: '100%', tableLayout: 'fixed' }}>
                        <thead >
                            <tr className="text-semibold" style={{ borderBottom: '1px solid #E6E6E6', paddingBottom: 20 }}>
                                {
                                    header && header.map((head, idx) => (
                                        <th key={idx} style={{ width: head.width || 'auto', color: "#1D1B1B" }}>
                                            {head.title}
                                        </th>
                                    ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                formValue?.length > 0 && formValue.map((val, idx) => {
                                    return (
                                        renderInputField(val, idx)
                                    )
                                })
                            }
                            {
                                (tableData && tableData.length > 0) ? (
                                    tableData.map((item, idx) => {
                                        return (
                                            <tr>
                                                {
                                                    header && header.map((head, index) => (
                                                        <td style={{ width: head?.width || 'auto' }}>
                                                            {
                                                                head?.accessor ?
                                                                    head.accessor(item, idx)
                                                                    : null
                                                            }
                                                        </td>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={header?.length} style={{ textAlign: 'center', padding: '32px 0', color: '#8F8F8F' }}>
                                            Nothing here yet
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
            }

        </Box>
    )
}

export default TableStyle2;